class DialogPopin extends HTMLElement {
  constructor() {
    super();
    // Initialize a property to store the last focused element
    this.lastFocusedElement = null;
    // Define the close button selector
    this.closeButtonSelector = '.js-popin__close';
  }
  connectedCallback() {
    // props

    // bindings
    this.bndHandleClose = this.handleClose.bind(this);
    this.bndHandleKeydown = this.handleKeydown.bind(this);
    this.bndHandleClick = this.handleClick.bind(this);

    // events
    if (document.readyState === 'complete') {
      this.onload();
    } else {
      window.addEventListener('load', () => {
        this.onload();
      }, {
        once: true
      });
    }
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.bndHandleClick);
    document.removeEventListener('keydown', this.bndHandleKeydown);
  }
  onload() {
    // events
    this.addEventListener('click', this.bndHandleClick);
    document.addEventListener('keydown', this.bndHandleKeydown);
  }
  handleClose(event) {
    event.preventDefault();
    this.setAttribute('hidden', '');
    this.setAttribute('tabindex', '-1');

    // Restore focus to the last focused element
    if (this.lastFocusedElement) {
      this.lastFocusedElement.focus();
    }
  }
  handleOpen(event) {
    event.preventDefault();

    // Save the currently focused element before opening the popin
    this.lastFocusedElement = document.activeElement;
    this.removeAttribute('hidden');
    this.removeAttribute('tabindex');

    // Focus the first focusable element in the popin
    setTimeout(() => {
      const focusableElements = this.querySelectorAll('a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])');
      const firstFocusableElement = focusableElements[0];
      if (firstFocusableElement) {
        firstFocusableElement.focus();
      } else {
        // If no focusable elements found, focus the popin itself
        this.setAttribute('tabindex', '0');
        this.focus();
      }
    }, 50); // Small timeout to ensure the popin is visible before setting focus
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && !this.hasAttribute('hidden')) {
      this.handleClose(event);
    }
  }
  handleClick(event) {
    const closeButton = event.target.closest(this.closeButtonSelector);
    if (!closeButton) return;
    this.handleClose(event);
  }
}
customElements.define('dialog-popin', DialogPopin);